module.exports = __webpack_public_path__ + "static/design-thinking-workshop-a3c6476a89453284912b2bc450ff2594.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/resources/design-thinking-workshop.png
// module id = 2683
// module chunks = 157636680307020